import { render, staticRenderFns } from "./OnboardSideBox.vue?vue&type=template&id=61f523f8&"
import script from "./OnboardSideBox.vue?vue&type=script&lang=js&"
export * from "./OnboardSideBox.vue?vue&type=script&lang=js&"
import style0 from "./OnboardSideBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports